<script>
  // @ts-nocheck
  import { page } from "$app/stores";
  import Alert from "$lib/components/NotAler.svelte";
  import AlertAuth from "$lib/components/AlertAuth.svelte";
  import SuccesWatchList from "$lib/components/SuccesWatchList.svelte";
  import SizeVariants from "$lib/components/SizeVariants.svelte";
  import { lang } from "$lib/translations/cartproduct";
  import ConfirmSize from "$lib/components/ConfirmSize.svelte";
  import Sign from "$lib/components/Sign.svelte";
  import AddBasketSucces from "$lib/components/AddBasket.svelte";
  export let data;
  import { basketListnew, basketId } from "$lib/store/newbasket";

  import { env as public_env } from "$env/dynamic/public";
  import CartProduct from "$lib/components/CartProduct.svelte";
  import Loader from "$lib/components/Loader.svelte";
  import { basketList } from "$lib/store/basket";
  import { favoritesList } from "$lib/store/favorites";
  import prev from "$lib/images/slideleft.svg";
  import next from "$lib/images/slideright.svg";

  import mprev from "$lib/images/mobp.svg";
  import mnext from "$lib/images/mobn.svg";
  // !!! 714
  import prevvar from "$lib/images/varprev.svg";
  import nextvar from "$lib/images/varnext.svg";
  import { goto } from "$app/navigation";
  import { variables } from "$lib/variables";
  import { onMount } from "svelte";
  import MobileGallery from "$lib/components/MobileGallery.svelte";
  import BasketPage from "$lib/components/BasketPage.svelte";
  import Gallery from "$lib/components/Gallery.svelte";
  import { browser } from "$app/environment";
  import VariantSize from "$lib/components/VariantSize.svelte";
  import PopularMes from "$lib/components/PopularMes.svelte";
  import { includes } from "lodash-es";

  function makePairs(arr, len) {
    let result = [];
    for (let i = 0; i < arr.length; i += len) {
      result.push([arr[i], arr[i + 1]]);
    }
    // if (result.length == 2){
    // 	result[0] = [result[0],result[0]]
    // 	result[1] = [result[1],result[1]]
    // }
    return result;
  }
  let images = makePairs(data.product.product_atribute.photos, 2);
  let mobileImages = data.product.product_atribute.photos;
  let activeimages = images[0];
  let activemobileImages = mobileImages[0];

  function MakeForVariants(Are, total) {
    let Are2 = [];

    for (let i = 0; i < Are.length; i += total) {
      Are2.push(Are.slice(i, i + total));
    }
    return Are2;
  }
  let opensuccess = false;
  let messagetext = "";
  let listDostypVariants = [
    ...data.product.atributes.filter((el) => el.total > 0),
    ...data.product.paralels_atributes,
  ].slice(0, 16);
  let mobilelistDostypVariants = listDostypVariants;

  listDostypVariants = MakeForVariants(listDostypVariants, 4);

  let activeDostypVariant = listDostypVariants[0];
  function NextVariant() {
    let index = listDostypVariants.indexOf(activeDostypVariant);
    // activeimages = [];
    activeDostypVariant = [];
    setTimeout(() => {
      if (index === listDostypVariants.length - 1) {
        // Если текущее изображение - последнее в списке, переходите к первому
        activeDostypVariant = listDostypVariants[0];
      } else {
        // Иначе переходите к следующему изображению
        activeDostypVariant = listDostypVariants[index + 1];
      }
    }, 250);
  }

  function PrevVariant() {
    let index = listDostypVariants.indexOf(activeDostypVariant);
    // activeimages = [];
    activeDostypVariant = [];
    setTimeout(() => {
      if (index === 0) {
        // Если текущее изображение - первое в списке, переходите к последнему
        activeDostypVariant = listDostypVariants[listDostypVariants.length - 1];
      } else {
        // Иначе переходите к предыдущему изображению
        activeDostypVariant = listDostypVariants[index - 1];
      }
    }, 250);
  }
  function handleClickGalleryPrev() {
    let index = images.indexOf(activeimages);
    // activeimages = [];

    if (index === 0) {
      // Если текущее изображение - первое в списке, переходите к последнему
      activeimages = images[images.length - 1];
    } else {
      // Иначе переходите к предыдущему изображению
      activeimages = images[index - 1];
    }
  }
  function handleClickGalleryNext() {
    let index = images.indexOf(activeimages);
    // activeimages = [];

    if (index === images.length - 1) {
      // Если текущее изображение - последнее в списке, переходите к первому
      activeimages = images[0];
    } else {
      // Иначе переходите к следующему изображению
      activeimages = images[index + 1];
    }
  }
  let openalertauth = false;
  let hoverActive = false;
  function AddFavorite() {
    let item = data.product.product_atribute;
    if (
      $favoritesList.filter(function (e) {
        return e.item.id == item.id;
      }).length > 0
    ) {
      let new_arr = $favoritesList.filter((e) => {
        return e.item.id != item.id;
      });
      $favoritesList = [...new_arr];
    } else {
      $favoritesList = [
        ...$favoritesList,
        {
          item,
        },
      ];
    }

    setTimeout(() => {
      localStorage.setItem("favorites", JSON.stringify($favoritesList));
    }, 500);
  }
  let OpenBasket = false;
  async function GetBasket(pk) {
    let url = `${variables.basePathApi}/api/v1/orders/${pk}/`;
    const res = await fetch(url);
    $basketListnew = await res.json();
    load = false;
  }
  async function GetBasketNew() {
    let urls = `${variables.basePathApi}/api/v1/orders/user-auth/`;
    if ($page.data.access) {
      const res = await fetch(urls, {
        headers: {
          Authorization: "Bearer " + $page.data.access,
        },
      });
      if (res.status === 200) {
        let baskData = await res.json();
        const resLogin = await fetch("/create-basket-cookie", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ basketId: baskData.id }),
        });
        if (resLogin.status == 200) {
          $basketListnew = baskData;
          $basketId = baskData.id;
          AddBasket();
        }
      }
    } else {
      const res = await fetch(urls, {});
      if (res.status === 200) {
        let baskData = await res.json();
        const resLogin = await fetch("/create-basket-cookie", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ basketId: baskData.id }),
        });
        if (resLogin.status == 200) {
          $basketListnew = baskData;
          $basketId = baskData.id;
          AddBasket();
        }
        $basketListnew = baskData;
        $basketId = baskData.id;
      }
    }
  }
  let penConfirmAddBasketSize = false;
  async function AddBasket() {
    if (!$basketId) {
      return GetBasketNew();
    }
    load = true;
    let item = data.product.product_atribute;
    
    // Если только один размер, автоматически выбираем его
    let productId = item.id;
    if (item.get_sizes_origin_product.length === 1) {
      productId = item.get_sizes_origin_product[0].id;
    }

    if (
      $basketListnew?.order_items.filter((el) => {
        return el.product.id === productId;
      }).length
    ) {
      load = false;
      return (OpenBasket = true);
    }
    let datasend = {
      user: $page.data.user?.id,
      phone: $page.data.user?.phone || "",
      email: $page.data.user?.email || "",
      street: $page.data.user?.street || "",
      fio: $page.data.user?.fio || "",
      fname: $page.data.user?.fname || "",
      oname: $page.data.user?.oname || "",
      name: $page.data.user?.name || "",
      city: $page.data.user?.city || "",
      region: $page.data.user?.region || "",
      index: $page.data.user?.index || "",
      address: "",
      house: $page.data.user?.house || "",
      kv: $page.data.user?.kv || "",
      order_items: [
        {
          product: productId,
          total: 1,
        },
      ],
    };
    let url = `${variables.basePathApi}/api/v1/orders/`;
    let method = "POST";

    if ($basketId) {
      url = `${variables.basePathApi}/api/v1/orders/${$basketId}/`;
      method = "PUT";
    }
    const res = await fetch(url, {
      method: method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(datasend),
    });
    if (res.status === 201 || res.status === 200) {
      let payload = await res.json();

      localStorage.setItem("basketId", payload.id);
      $basketId = payload.id;

      await GetBasket(payload.id);
      load = false;
      SuccesMessage3 = true;
    }
    load = false;
    return;
    item.count = 1;
    // @ts-ignore
    if (Number(item.sale_price) != 0) {
      item.totalprice = item.sale_price;
    } else {
      item.totalprice = item.price;
    }
    item.weight = item.product.weight;
    item.height = item.product.height;
    item.width = item.product.width;
    item.length = item.product.length;

    // if($basketList.length === 0){

    // 	$basketList.order_id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    // 	$basketList = $basketList
    // }

    if (
      $basketList.filter(function (e) {
        return e.item.id == item.id;
      }).length > 0
    ) {
      let new_arr = $basketList.filter((e) => {
        return e.item.id != item.id;
      });
      $basketList = [...new_arr];
    } else {
      $basketList = [
        ...$basketList,
        {
          item,
        },
      ];
      OpenBasket = true;
    }

    setTimeout(() => {
      localStorage.setItem("basket", JSON.stringify($basketList));
    }, 500);
  }
  let openConfirmAddBasketSize = false;
  async function AddBasketVariant(variant_id) {
    openConfirmAddBasketSize = false;
    if ($page.data.product.product_atribute.pre_order) {
      goto(`/cart-pre-order/?product_id=${variant_id}`);
      return;
    }
    if (!$basketId) {
      return GetBasketNew();
    }

    load = true;

    if (
      $basketListnew?.order_items.filter((el) => {
        return el.product.id === variant_id;
      }).length
    ) {
      load = false;
      return (OpenBasket = true);
    }
    let data = {
      user: $page.data.user?.id,
      phone: $page.data.user?.phone || "",
      email: $page.data.user?.email || "",
      street: $page.data.user?.street || "",
      fio: $page.data.user?.fio || "",
      fname: $page.data.user?.fname || "",
      oname: $page.data.user?.oname || "",
      name: $page.data.user?.name || "",
      city: $page.data.user?.city || "",
      region: $page.data.user?.region || "",
      index: $page.data.user?.index || "",
      address: "",
      house: $page.data.user?.house || "",
      kv: $page.data.user?.kv || "",
      order_items: [
        {
          product: variant_id,
          total: 1,
        },
      ],
    };
    let url = `${variables.basePathApi}/api/v1/orders/`;
    let method = "POST";

    if ($basketId) {
      url = `${variables.basePathApi}/api/v1/orders/${$basketId}/`;
      method = "PUT";
    }
    const res = await fetch(url, {
      method: method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (res.status === 201 || res.status === 200) {
      let payload = await res.json();

      localStorage.setItem("basketId", payload.id);
      $basketId = payload.id;
      await GetBasket(payload.id);
      load = false;
    }
    load = false;
    SuccesMessage3 = true;
    return;
  }
  	function AddToCart() {
  		// Проверяем количество размеров
  		if (data.product.product_atribute.get_sizes_origin_product.length > 1) {
  			openConfirmAddBasketSize = true;
  		} else {
  			AddBasket();
  		}
  	}
  // function AddBasket() {
  // 	let item = data.product.product_atribute;
  // 	item.count = 1;
  // 	// @ts-ignore
  // 	if (Number(item.sale_price) != 0) {
  // 		item.totalprice = item.sale_price;
  // 	} else {
  // 		item.totalprice = item.price;
  // 	}
  // 	item.weight = item.product.weight;
  // 	item.height = item.product.height;
  // 	item.width = item.product.width;
  // 	item.length = item.product.length;

  // 	// if($basketList.length === 0){

  // 	// 	$basketList.order_id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  // 	// 	$basketList = $basketList
  // 	// }

  // 	if (
  // 		$basketList.filter(function (e) {
  // 			return e.item.id == item.id;
  // 		}).length > 0
  // 	) {
  // 		let new_arr = $basketList.filter((e) => {
  // 			return e.item.id != item.id;
  // 		});
  // 		$basketList = [...new_arr];
  // 	} else {
  // 		$basketList = [
  // 			...$basketList,
  // 			{
  // 				item
  // 			}
  // 		];
  // 	}

  // 	setTimeout(() => {
  // 		localStorage.setItem('basket', JSON.stringify($basketList));
  // 	}, 500);

  // }
  let openGallery = false;
  let imgact = "";
  if (activeimages) {
    imgact = `${variables.basePathApi}${activeimages[0].image_thumbnail}`;
  }
  // Функция для фильтрации уникальных размеров
  function filterUniqueSizes(attributes) {
    let seenIds = new Set();
    return attributes.filter((attribute) => {
      const isUnique = !seenIds.has(attribute.sizes.id);
      seenIds.add(attribute.sizes.id);
      return isUnique;
    });
  }
  let openSelect = false;
  let activeSizeVariant = null;
  let alertMessage = false;
  let textalert = "";
  let color = "rgb(240 253 244)";
  let openAlert = false;
  onMount(async () => {
    setTimeout(() => {
      let excBasketitem = $basketListnew.order_items.filter((el) => {
        return data.product.size_atribute.map((it) => it.id === el.product.id);
      });

      if (excBasketitem.length > 0) {
        activeSizeVariant = data.product.size_atribute.filter((el) => {
          return el.id === excBasketitem[0].product.id;
        })[0];
      }
    }, 1000);
  });
  let sizeAttributes = data.product.size_atribute;
  // Получаем массив уникальных размеров
  let uniqueSizeAttributes = filterUniqueSizes(sizeAttributes);
  let load = false;
  let SuccesMessage3 = false;
  let signin = false;
  let videoId;
  try {
    let videoId = data.product.product_atribute.link_video
      .split("?")[0]
      .split("/")
      .pop();
  } catch (error) {}

  let embedLink;
  // Формирование ссылки для встраивания
  if (videoId) {
    embedLink = `https://www.youtube.com/embed/${videoId}`;
  }
  async function AddWatchList(product_attribute_id) {
    console.log(123445);
    let url = `${variables.basePathApi}/api/v1/add-to-wishlist/`;
    if ($page.data.access) {
      openConfirmAddBasketSize = false;
      let data = { product_attribute_id: product_attribute_id };
      load = true;
      let method = "POST";
      const res = await fetch(url, {
        method: method,
        headers: {
          Authorization: "Bearer " + $page.data.access,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      // const res = await fetch(urls, {
      //   method: "POST",
      //   headers: {
      //     Accept: "application/json",
      //     "Content-Type": "application/json",
      //     Authorization: "Bearer " + $page.data.access,
      //     body: JSON.stringify({ product_attribute_id: product_attribute_id }),
      //   },
      // });
      if (res.status === 201 || res.status === 200) {
        let data = await res.json();
        if (data.message) {
          opensuccess = true;
          messagetext = data.message;
        }
      }
      load = false;
    } else {
      openConfirmAddBasketSize = false;
      openalertauth = true;
    }
  }
</script>

<svelte:head>
  <title
    >Iloveitalianbags - купить {data.product.product_atribute.product.name} из Италии.</title
  >
  <meta
    name="description"
    content="Купить {data.product.product_atribute.product
      .name} из Италии. Купить. Быстрая доставка.{data.product.product_atribute
      .product.name} категории({data.category.name}) из Италии."
  />
  <meta
    data-n-head="ssr"
    data-hid="og:description"
    property="og:description"
    content="Купить {data.product
      .name} из Италии. Купить. Быстрая доставка.{data.product.product_atribute
      .product.name} категории({data.category.name}) из Италии."
  />
  <meta
    data-n-head="ssr"
    data-hid="og:description"
    name="og:description"
    content="Купить {data.product.product_atribute.product
      .name} из Италии. Купить. Быстрая доставка.{data.product.product_atribute
      .product.name} категории({data.category.name}) из Италии."
  />
  <meta
    data-n-head="ssr"
    data-hid="og:title"
    property="og:title"
    content="Iloveitalianbags - купить {data.product.product_atribute.product
      .name} из Италии."
  />
  <meta
    data-n-head="ssr"
    data-hid="og:title"
    name="og:title"
    content="Iloveitalianbags - купить {data.product.product_atribute.product
      .name} из Италии."
  />
  <meta
    name="og:description"
    content="Купить {data.product.product_atribute.product
      .name} из Италии. Купить. Быстрая доставка.{data.product.product_atribute
      .product.name} категории({data.category.name}) из Италии."
  />
  <link
    rel="canonical"
    href="https://iloveitalianbags.ru{$page.url.pathname}"
  />
  <meta property="og:image" content={imgact} />
  <meta property="og:image:width" content="1200" />
  <meta property="og:image:height" content="630" />
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/lightgallery/2.7.1/css/lightgallery.min.css"
    integrity="sha512-F2E+YYE1gkt0T5TVajAslgDfTEUQKtlu4ralVq78ViNxhKXQLrgQLLie8u1tVdG2vWnB3ute4hcdbiBtvJQh0g=="
    crossorigin="anonymous"
    referrerpolicy="no-referrer"
  />
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/lightgallery/2.7.1/css/lightgallery-bundle.min.css"
    integrity="sha512-nUqPe0+ak577sKSMThGcKJauRI7ENhKC2FQAOOmdyCYSrUh0GnwLsZNYqwilpMmplN+3nO3zso8CWUgu33BDag=="
    crossorigin="anonymous"
    referrerpolicy="no-referrer"
  />
</svelte:head>
{#if openalertauth}
  <AlertAuth bind:openalertauth />
{/if}
{#if opensuccess}
  <SuccesWatchList bind:opensuccess {messagetext} />
{/if}
{#if openConfirmAddBasketSize}
	<ConfirmSize
		bind:openConfirmAddBasketSize
		item={data.product.product_atribute}
		{AddBasketVariant}
		{AddWatchList}
	/>
{/if}
{#if signin}
  <Sign bind:signin />
{/if}
{#if SuccesMessage3}
  <AddBasketSucces bind:SuccesMessage3 item={data.product.product_atribute} />
{/if}
{#if load}
  <Loader />
{/if}
{#if browser}
  {#if OpenBasket}
    <BasketPage bind:OpenBasket />
  {/if}
{/if}
{#if browser}
  {#if openGallery}
    <Gallery images={data.product.product_atribute.photos} />
  {/if}
{/if}
{#if alertMessage}
  <Alert bind:alertMessage bind:textalert bind:color />
{/if}
<div class="hidden md:block">
  <div
    class="duration-700 relative pb-4 bg-white h-full grid grid-cols-12 ease-in-out"
    data-carousel-item
  >
    <div
      class="absolute top-[50%] py-3 z-10 flex pr-[21px] pl-[21px] justify-between items-center left-0 w-full"
    >
      {#if images.length > 1}
        <button
          on:click={() => {
            handleClickGalleryPrev();
          }}><img height="50" width="20" src={prev} alt="" /></button
        >
        <button
          on:click={() => {
            handleClickGalleryNext();
          }}><img height="50" width="20" src={next} alt="" /></button
        >
      {/if}
    </div>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
      on:click={() => {
        openGallery = false;
        setTimeout(() => {
          openGallery = true;
        }, 150);
      }}
      class="col-span-6 cursor-pointer h-[97vh] bg-cover"
      style="background-image: url({activeimages[0]
        .image});background-position: center;"
    />

    <div
      class="absolute top-[50%] left-[43%] hidden md:flex justify-center items-center"
    >
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div
        class="bg-[#FFFFFF] cursor-pointer w-[270px] px-[25px] h-[150px] flex flex-col justify-center items-center"
      >
        <p class="text-lg text-center text-[#000000] font-[400]">
          {data.product.product_atribute.product[`name${$page.data.host}`]}
        </p>
        {#if data.product.product_atribute.total > 0}
          {#if !data.product.product_atribute.pre_order}
            {#if !$basketList.filter((el) => {
              return el.item.id == data.product.product_atribute.id;
            }).length}
              <button
                on:click={() => {
                  AddToCart();
                }}
                class="bg-[#3D3D3D] z-10 mt-3 w-full py-2 px-4 text-white"
              >
                {#if $page.data.host === "ARM"}
                  Գնել
                {:else}
                  КУПИТЬ
                {/if}
              </button>
            {/if}
          {:else}
            <button
              on:click={() => {
                // if (!$page.data.user) {
                // 	openAlert = true;
                // } else {
                // 	goto(`/cart-pre-order/?product_id=${data.product.product_atribute.id}`);
                // }
                if (!$page.data.user) {
                  openAlert = true;
                } else {
                  AddToCart();
                }
              }}
              class="bg-[#3D3D3D] z-10 mt-3 w-full py-2 px-4 text-white"
            >
              Оформить предзаказ
            </button>
          {/if}
        {/if}
      </div>
    </div>
    {#if activeimages[1]}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div
        on:click={() => {
          openGallery = false;
          setTimeout(() => {
            openGallery = true;
          }, 150);
        }}
        class="col-span-6 h-[97vh] cursor-pointer bg-cover p-2"
        style="background-image: url({activeimages[1]
          .image});background-position: center;"
      />
    {:else}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div
        on:click={() => {
          openGallery = false;
          setTimeout(() => {
            openGallery = true;
          }, 150);
        }}
        class="col-span-6 cursor-pointer h-[97vh] bg-cover p-2"
        style="background-image: url({activeimages[0]
          .image});background-position: center;"
      />
    {/if}
    {#if images.length > 1}
      <div
        class="col-span-12 text-[#484848] text-lg flex justify-center items-center"
      >
        {images.indexOf(activeimages) + 1}/{Math.floor(
          Number(data.product.product_atribute.photos.length / 2)
        ) || 1}
      </div>
    {/if}
  </div>
</div>
<!-- Mobile gallery -->
<div class="md:hidden block mt-[6em]">
  <div class="px-[30px] pb-[60px] flex flex-col">
    <MobileGallery images={data.product.product_atribute.photos} />
    <div>
      <p class="text-xl text-custom-black text-center mt-6">
        {data.product.product_atribute.product[`name${$page.data.host}`]}
      </p>
    </div>
    <div>
      <!-- <button
				on:click={() => {
					goto(`/${data.product.product_atribute.product.category.slug}`);
				}}
				class="w-full bg-custom-dark-bg py-[15px] mt-[28px] text-[14px] text-custom-white-bg font-normal text-center"
				>ПОСМОТРЕТЬ КАТАЛОГ</button
			> -->
      {#if data.product.product_atribute.total > 0}
        {#if !data.product.product_atribute.pre_order}
          {#if !$basketList.filter((el) => {
            return el.item.id == data.product.product_atribute.id;
          }).length}
            <button
              on:click={() => {
                AddToCart();
              }}
              class="bg-[#3D3D3D] z-10 mt-3 w-full py-2 px-4 text-white"
            >
              {#if $page.data.host === "ARM"}
                Գնել
              {:else}
                КУПИТЬ
              {/if}
            </button>
          {/if}
        {:else}
          <button
            on:click={() => {
              if (!$page.data.user) {
                openAlert = true;
              } else {
                AddToCart();
              }
            }}
            class="bg-[#3D3D3D] z-10 mt-3 w-full py-2 px-4 text-white"
          >
            Оформить предзаказ
          </button>
        {/if}
      {/if}
    </div>
  </div>
</div>

<div class="bg-custom-gray-bg md:block hidden px-[21px] py-[50px]">
  {#if activeDostypVariant}
    {#if activeDostypVariant.length > 0}
      {#if $page.data.host === "ARM"}
        <h2 class="text-2xl text-custom-gray">ԱՅԼ ՄԱՏՉԵԼԻ ՏԱՐԲԵՐԱԿՆԵՐ</h2>
      {:else}
        <h2 class="text-2xl text-custom-gray">ДРУГИЕ ДОСТУПНЫЕ ВАРИАНТЫ</h2>
      {/if}
    {/if}
  {/if}
</div>
<div class="min-h-screen grid grid-cols-1 md:grid-cols-2">
  <!-- Paralels variants -->
  <div
    class="bg-custom-white-bg md:bg-custom-gray-bg order-2 md:order-1 md:min-h-[111vh]"
  >
    <!-- MOBILE -->
    <div class="hidden md:grid bg-[#ffffff] grid-cols-2 gap-[2px]">
      {#if activeDostypVariant}
        {#if activeDostypVariant.length > 0}
          {#each activeDostypVariant as item, ind}
            <CartProduct reload={true} {item} {ind} />
          {/each}
        {/if}
      {/if}
    </div>
    <div class="grid md:hidden grid-cols-1 gap-[1px]">
      {#each mobilelistDostypVariants as item, ind}
        <CartProduct reload={true} {item} {ind} />
      {/each}
    </div>
    {#if activeDostypVariant}
      {#if activeDostypVariant.length > 0}
        <div
          class="hidden md:flex pt-[43px] pb-[54px] justify-center items-center"
        >
          <div>
            <button
              on:click={() => {
                PrevVariant();
              }}
              class="mr-[22px]"
            >
              <img width="6" height="9" src={prevvar} alt="" />
            </button>

            <span class="text-sm text-[#484848]"
              >{listDostypVariants.indexOf(activeDostypVariant) +
                1}/{listDostypVariants.length}</span
            >
            <button
              on:click={() => {
                NextVariant();
              }}
              class="ml-[22px]"
            >
              <img width="6" height="9" src={nextvar} alt="" />
            </button>
          </div>
        </div>
      {/if}
    {/if}
  </div>

  <!-- Descriptions -->
  <div
    class="bg-custom-white-bg order-1 md:order-2 px-[30px] md:px-[57px] py-[30px] md:py-[67px]"
  >
    <div class="md:w-[70%]">
      <div class="hidden md:inline-flex justify-start text-custom-gray text-sm">
        <a href="/">
          {#if $page.data.host === "ARM"}
            Գլխավոր էջ
          {:else}
            Главная
          {/if}
        </a><span class="ml-1">/</span>
        {#if data.product.product_atribute.product.category}
          <a
            class="ml-1"
            href="/{data.product.product_atribute.product.category.slug}"
          >
            {data.product.product_atribute.product.category[
              `name${$page.data.host}`
            ]}
          </a>
        {:else if data.product.product_atribute.product.brand}
          <a
            class="ml-1"
            href="/{data.product.product_atribute.product.brand.slug}-b"
          >
            {data.product.product_atribute.product.brand[
              `name${$page.data.host}`
            ]}
          </a>
        {/if}
        <span class="ml-1">/</span>
        <span class="ml-1"
          >{data.product.product_atribute.product[
            `name${$page.data.host}`
          ]}</span
        >
      </div>
      {#if data.product.product_atribute.get_sizes_origin_product.length}
        <div class="mb-6">
          <VariantSize item={$page.data.product.product_atribute} />
        </div>
      {/if}
      <div />

      <div class="mt-[10px] text-start">
        <h1 class=" text-lg font-bold">
          {data.product.product_atribute.product[`name${$page.data.host}`]}
        </h1>
      </div>

      <div class="mt-[30px] text-start">
        <p class=" text-custom-gray text-base">
          {@html data.product.product_atribute.product[
            `descriptions${$page.data.host}`
          ] || "Нет описания"}
        </p>
      </div>
      <div
        class="mt-[20px] hidden md:block"
        style="border-bottom: 0.5px solid #D9D9D9;"
      />
      <div class="mt-[30px] text-center">
        {#if !data.product.product_atribute.pre_order}
          {#if Number(data.product.product_atribute.sale_price) === 0}
            <p class=" text-custom-black text-2xl font-bold">
              {Number(data.product.product_atribute.price).toLocaleString("ru")}
              ₽
            </p>
          {:else}
            <p class=" text-custom-black text-2xl font-bold">
              {Number(data.product.product_atribute.sale_price).toLocaleString(
                "ru"
              )}
              ₽
            </p>
          {/if}
        {:else}
          <!-- <p class=" text-custom-black text-2xl font-bold">
						Полная стоимость ~ {Number(data.product.product_atribute.price).toLocaleString('ru')}
						₽
					</p> -->
          <p class=" text-custom-black text-2xl font-bold">
            Цена предзаказа {Number(
              data.product.product_atribute.price_pre_order
            ).toLocaleString("ru")}
            ₽
          </p>
          {#if data.product.product_atribute.description_pre_order}
            <p class="mt-4 mb-4 text-gray-600">
              {data.product.product_atribute.description_pre_order}
            </p>
          {/if}
        {/if}
      </div>
      <!-- {#if uniqueSizeAttributes.length > 1}
				<div id="sizevar" class="flex justify-center mt-[27px]">
					<SizeVariants
						variantssizes={uniqueSizeAttributes}
						bind:openSelect
						bind:activeSizeVariant
					/>
				</div>
			{/if} -->

      <div class="flex justify-center mt-[27px]">
        {#if !data.product.product_atribute.pre_order}
          {#if data.product.product_atribute.total > 0}
            {#if !$basketListnew?.order_items.filter((el) => {
              return el.product.id === data.product.product_atribute.id;
            }).length}
              <button
                on:mouseenter={() => {
                  hoverActive = true;
                }}
                on:mouseleave={() => {
                  hoverActive = false;
                }}
                on:click={() => {
                  AddToCart();
                }}
                class:border-custom-black={!hoverActive}
                class:border-bg-custom-gray3={hoverActive}
                class="w-full border-solid border-1 hover:bg-custom-gray3 hover:text-custom-white-bg py-[14px] text-base md:text-[10px] font-semibold text-center"
                ><span>{lang[$page.data.host]["addbaskettile"]}</span></button
              >
            {:else}
              <button
                on:mouseenter={() => {
                  hoverActive = true;
                }}
                on:mouseleave={() => {
                  hoverActive = false;
                }}
                on:click={() => {
                  OpenBasket = true;
                }}
                class:border-custom-black={!hoverActive}
                class:border-bg-custom-gray3={hoverActive}
                class="w-full font-semibold border-solid border-1 hover:bg-custom-gray3 hover:text-custom-white-bg py-[14px] text-base md:text-[10px] text-center"
                >{lang[$page.data.host]["tobaskettile"]}
              </button>
            {/if}
          {:else if $page.data.host != "ARM"}
            <span class="w-full">Нет в наличии</span>
            <button
              on:click={() => {
                AddWatchList($page.params.id);
              }}
              class:border-custom-black={!hoverActive}
              class:border-bg-custom-gray3={hoverActive}
              class="w-full mt-10 mb-4 md:h-12 h-10 border-solid border-1 hover:bg-custom-gray3 hover:text-custom-white-bg md:py-[14px] py-[8px] text-[10px] font-semibold text-center"
            >
              в лист ожидания
            </button>
          {/if}
        {:else}
          <button
            on:mouseenter={() => {
              hoverActive = true;
            }}
            on:mouseleave={() => {
              hoverActive = false;
            }}
            on:click={() => {
              if (!$page.data.user) {
                openAlert = true;
              } else {
                AddToCart();
              }
            }}
            class:border-custom-black={!hoverActive}
            class:border-bg-custom-gray3={hoverActive}
            class="w-full border-solid border-1 hover:bg-custom-gray3 hover:text-custom-white-bg py-[14px] text-base md:text-[10px] font-semibold text-center"
            ><span>Оформить предзаказ</span></button
          >
        {/if}
      </div>

      {#if $page.data.host != "ARM"}
        <div class="mt-[70px]">
          <ul style="list-style-type: disc;list-style-position: inside;">
            <li>
              <span class="text-custom-gray text-base"
                >Артикул: <span class="ml-2"
                  >{data.product.product_atribute.individual_article}</span
                >
              </span>
            </li>

            {#if data.product.product_atribute.color}
              <li class="mt-2">
                <span class="text-custom-gray text-base"
                  >Цвет: <span class="ml-2"
                    >{data.product.product_atribute.color[
                      `name${$page.data.host}`
                    ]}</span
                  >
                </span>
              </li>
            {/if}

            {#if data.product.product_atribute.sizes}
              <li class="mt-2">
                <span class="text-custom-gray text-base"
                  >Размер: <span class="ml-2"
                    >{data.product.product_atribute.sizes.european ||
                      data.product.product_atribute.sizes.international}</span
                  >
                </span>
              </li>
            {/if}
            {#if data.product.product_atribute.product.material}
              <li class="mt-2">
                <span class="text-custom-gray text-base"
                  >Материал: <span class="ml-2"
                    >{data.product.product_atribute.product[
                      `material${$page.data.host}`
                    ]}</span
                  >
                </span>
              </li>
            {/if}

            {#if data.product.product_atribute.product.brand}
              <li class="mt-2">
                <span class="text-custom-gray text-base"
                  >Бренд: <span class="ml-2"
                    >{data.product.product_atribute.product.brand.name}</span
                  >
                </span>
              </li>
            {/if}
            <!-- {#if data.product.product_atribute.color}
						<li class="mt-2">
							<span class="text-custom-gray text-base"
								>Цвет: <span class="ml-2">{data.product.product_atribute.color.name}</span>
							</span>
						</li>
					{/if} -->
            <li class="mt-2">
              <span class="text-custom-gray text-base">
                Производство: Италия
              </span>
            </li>
            {#if $page.data.host != "ARM"}
              {#if data.product.product_atribute.product.specifications.length > 0}
                {#each data.product.product_atribute.product.specifications as specification}
                  {#if (specification.title.includes("Размер") || !data.product.product_atribute.sizes) && !specification.title.includes("Бренд") && (!data.product.product_atribute.product.material || !specification.title.includes("Материал"))}
                    <li class="mt-2">
                      <span class="text-custom-gray text-base">
                        {specification[`title${$page.data.host}`]}: {specification[
                          `value${$page.data.host}`
                        ]}
                      </span>
                    </li>
                  {/if}
                {/each}
              {/if}
            {/if}
          </ul>
        </div>
      {/if}
      <div class="mt-8 video-container">
        {#if data.product.product_atribute.link_video}
          {#if data.product.product_atribute.link_video.includes("<iframe")}
            {@html data.product.product_atribute.link_video}

            <!-- <iframe src="https://vk.com/video_ext.php?oid=-211497748&id=456239020&hd=2" width="853" height="480" allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;" frameborder="0" allowfullscreen></iframe> -->
            <!-- <iframe
							width="560"
							height="315"
							src={embedLink}
							title="YouTube video player"
							frameborder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowfullscreen
						/> -->
          {/if}
        {/if}
      </div>
    </div>
    {#if activeDostypVariant}
      {#if activeDostypVariant.length > 0}
        <h2
          class="text-[24px] mt-[80px] block md:hidden text-center text-custom-black"
        >
          ДРУГИЕ ДОСТУПНЫЕ ВАРИАНТЫ
        </h2>
      {/if}
    {/if}
  </div>
</div>
{#if openAlert}
  <div
    class="relative z-[2000]"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div
        class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
      >
        <div
          class="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
        >
          <div class="sm:flex sm:items-start">
            <div
              class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
            >
              <svg
                class="h-6 w-6 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                />
              </svg>
            </div>
            <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
              <h3
                class="text-base font-semibold leading-6 text-gray-900"
                id="modal-title"
              >
                Внимание
              </h3>
              <div class="mt-2">
                <p class="text-sm text-gray-500">
                  Для оформления покупок предзаказа необходима авторизация.
                </p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button
              on:click={() => {
                signin = true;

                goto(`?pathname=${$page.url.pathname}`);
              }}
              type="button"
              class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >Войти</button
            >
            <button
              on:click={() => {
                openAlert = false;
              }}
              type="button"
              class="inline-flex w-full mr-3 mt-3 md:mt-0 justify-center rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
              >Отмена</button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
  .video-container {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%; /* Пропорция 16:9 */
    height: 0;
  }
  /* .video-container iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 250px;

		height: 100%;
	} */
</style>
